import { curry } from 'lodash';

import fuzzysearch from '../fuzzysearch';

import { NAME } from './constants';

const matchesQuery = curry((query: string, service: { name: string }) => {
  return fuzzysearch(query, service[NAME]);
});

export default matchesQuery;
